import type { RootState } from "@core/store"
import { getStoredWebSessionUser } from "@core/utils/webSessionAuth"

export const resolveCurrentMemberUuidFromState = (state?: RootState | null): string | null => {
  const reduxMemberUuid = String(state?.member?.member?.memberUuid || "").trim()
  if (reduxMemberUuid) {
    return reduxMemberUuid
  }

  const storedSessionMemberUuid = String(getStoredWebSessionUser()?.memberUuid || "").trim()
  if (storedSessionMemberUuid) {
    return storedSessionMemberUuid
  }

  return null
}